{
  "validation.maxAttachments": "Puoi aggiungere solo {{max}} allegati.",
  "validation.minAttachments": "Sono richiesti almeno {{min}} allegati.",
  "validation.maxAttachmentSize": "Gli allegati non possono superare i {{max}} Megabyte.",
  "validation.attachmentListItemRequired": "Per favore, aggiungi un allegato per \"{{category}}\".",
  "validation.attachmentListItemMaxAttachments": "Puoi caricare solo {{max}} allegati per la categoria \"{{category}}\".",
  "validation.attachmentListItemMaxAttachmentSize": "Gli allegati di {{category}} non possono superare i {{max}} Megabyte.",
  "attachment.bsoCategory.DiagnosticReport": "Rapporto diagnostico",
  "attachment.bsoCategory.InvoiceDocument": "Documento della fattura",
  "attachment.bsoCategory.ShippingDocument": "Documento di spedizione",
  "attachment.bsoCategory.Letter": "Lettera",
  "attachment.bsoCategory.PictureReference": "Immagine di riferimento",
  "attachment.bsoCategory.BugReport": "Segnalazione bug",
  "attachment.bsoCategory.Other": "Altro",
  "attachment.bsoCategory.Unclassified": "Non classificato",
  "attachment.bsoCategory.ServiceForms": "Modulo di servizio",
  "attachment.bsoCategory.RegistrationDocument": "Documento di registrazione",
  "attachment.bsoCategory.ShopInside": "Foto dell’interno del negozio",
  "attachment.bsoCategory.ShopImageMigration": "Trasferimento immagini negozio",
  "attachment.bsoCategory.ShopImage": "Foto della vetrina",
  "attachment.uploadButton": "Carica {{category}}",
  "attachment.uploadDropdown": "Carica un file"
}